export default __webpack_public_path__ + "static/media/down.176659fb.svg";